var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 25,
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 26 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.757 12.927q-2.91-2.56-5.076-4.878t-2.167-4.33q0-1.584 1.084-2.652Q13.682 0 15.29 0q.93 0 1.842.503.913.503 1.625 1.357A5.7 5.7 0 0 1 20.382.503Q21.295 0 22.224 0q1.609 0 2.693 1.067Q26 2.134 26 3.72q0 2.011-2.167 4.329t-5.076 4.878m0-6.83",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgHeart;